import { toNumberOrNull } from 'utils/numberUtils';
import request from 'utils/request';

export const transformFiltersParamsToApi = ({
  assignedToIn,
  page,
  pageSize,
  quoteNumber,
  statusIn,
}) => ({
  assigned_to_in:
    assignedToIn && Array.isArray(assignedToIn) && assignedToIn.length > 0
      ? assignedToIn.join(',')
      : undefined,
  quote_number: quoteNumber || undefined,
  page: page || undefined,
  page_size: pageSize || undefined,
  status_in:
    statusIn && Array.isArray(statusIn) && statusIn.length > 0
      ? statusIn.join(',')
      : undefined,
});

export const transformApiToFilterParams = (queryParams) => {
  const assignedToIn = [];
  const statusIn = [];

  if (typeof queryParams.assigned_to_in === 'string') {
    queryParams.assigned_to_in.split(',').forEach((userId) => {
      if (toNumberOrNull(userId)) {
        assignedToIn.push(Number(userId));
      }
    });
  }

  if (typeof queryParams.status_in === 'string') {
    queryParams.status_in.split(',').forEach((status) => {
      statusIn.push(status);
    });
  }

  return {
    assignedToIn,
    quoteNumber: queryParams.quote_number || '',
    statusIn,
  };
};

export default {
  list: async (queryParams) => {
    return await request.get('/part_library/tasks', queryParams);
  },
};
